// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nqc6eoc_QdTtBh {
  overflow: visible;
}
.Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.rMEc6cZqNHDc_5 {
  width: 620px;
  margin-right: auto;
  margin-left: auto;
  transition: width 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.rMEc6cZqNHDc_5 {
    transition: none;
  }
}
.Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.rMEc6cZqNHDc_5.g0DDcnZtnJUWeu {
  width: 1080px;
}
@media only screen and (min-width: 637px) and (max-width: 1095px) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.rMEc6cZqNHDc_5.g0DDcnZtnJUWeu {
    width: calc(100vw - var(--ds-space-200, 16px));
  }
}
@media only screen and (max-width: 636px) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.rMEc6cZqNHDc_5,
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.rMEc6cZqNHDc_5.g0DDcnZtnJUWeu {
    width: calc(100vw - var(--ds-space-200, 16px));
    margin-right: var(--ds-space-100, 8px);
    margin-left: var(--ds-space-100, 8px);
  }
}
.Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.CT6tjCYFghSvzF {
  width: 620px;
  margin-right: auto;
  margin-left: auto;
  transition: width 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.CT6tjCYFghSvzF {
    transition: none;
  }
}
.Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.CT6tjCYFghSvzF.g0DDcnZtnJUWeu {
  width: 1080px;
}
@media only screen and (min-width: 936px) and (max-width: 1095px) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.CT6tjCYFghSvzF.g0DDcnZtnJUWeu {
    width: calc(100vw - var(--ds-space-200, 16px));
  }
}
@media only screen and (max-width: 935px) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.CT6tjCYFghSvzF,
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.CT6tjCYFghSvzF.g0DDcnZtnJUWeu {
    width: 620px;
  }
}
@media only screen and (max-width: 636px) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.CT6tjCYFghSvzF,
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.CT6tjCYFghSvzF.g0DDcnZtnJUWeu {
    width: calc(100vw - var(--ds-space-200, 16px));
    margin-right: var(--ds-space-100, 8px);
    margin-left: var(--ds-space-100, 8px);
  }
}
@media only screen and (max-width: 600px) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ {
    margin-top: var(--ds-space-400, 32px);
  }
}
@media only screen and (max-width: 750px) {
  .Nqc6eoc_QdTtBh > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: var(--ds-space-0, 0) !important;
  }
}
`, ""]);
// Exports
export var cardBackDialog = `Nqc6eoc_QdTtBh`;
export var cardBackRedesign = `zEJCz43wCjFqhZ`;
export var fixed = `rMEc6cZqNHDc_5`;
export var withPanel = `g0DDcnZtnJUWeu`;
export var resizable = `CT6tjCYFghSvzF`;
export default ___CSS_LOADER_EXPORT___;
